try {
            require('./index.css');
          } catch (e) {
            if (e.code !== 'MODULE_NOT_FOUND') {
              throw e; // Re-throw unexpected errors
            }
            console.warn('index.css not found, proceeding without it.');
          }
          

import { jsxs, jsx } from 'react/jsx-runtime';
import { RTEText } from '@design-system/rte-text';
import { Tooltip } from '@design-system/tooltip';
import { Typography } from '@design-system/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';

const FieldHead = forwardRef(({ className, id, label, tooltipLabel, tooltipText, tooltipContent, description, error, additionalHeadContent, }, ref) => (jsxs("div", Object.assign({ ref: ref, className: classNames('cds-field-head', className) }, { children: [jsxs("header", Object.assign({ className: "cds-field-head__header" }, { children: [jsx("label", Object.assign({ className: "cds-field-head__label", htmlFor: id }, { children: jsx(Typography, { tag: "span", variant: "headline", size: "xs", weight: "medium", content: label, className: classNames({
                            'cds-typography--variant-headline--error': Boolean(error),
                        }) }) })), tooltipLabel && (tooltipText || tooltipContent) ? (jsx(Tooltip, { label: tooltipLabel, text: tooltipText, content: tooltipContent })) : null, additionalHeadContent] })), description ? (jsx(RTEText, { className: "cds-field-head__description", text: description })) : null] }))));

export { FieldHead };
